import {List} from "immutable";
import {Maybe} from "ramda-fantasy";
import _ from "ramda";
import Syntax from "./syntax";
import {assert} from "./errors";
const isDolar_701 = s_710 => s_710 && s_710 instanceof Syntax && s_710.isIdentifier() && s_710.val() === "$";
const isDelimiter_702 = s_711 => s_711 && typeof s_711.isDelimiter === "function" && s_711.isDelimiter();
const isBraces_703 = s_712 => s_712 && typeof s_712.isBraces === "function" && s_712.isBraces();
const isParens_704 = s_713 => s_713 && typeof s_713.isParens === "function" && s_713.isParens();
const isBrackets_705 = s_714 => s_714 && typeof s_714.isBrackets === "function" && s_714.isBrackets();
const insertIntoDelimiter_706 = _.cond([[isBraces_703, (s_715, r_716) => Syntax.fromBraces(r_716, s_715)], [isParens_704, (s_717, r_718) => Syntax.fromParens(r_718, s_717)], [isBrackets_705, (s_719, r_720) => Syntax.fromBrackets(r_720, s_719)]]);
const process_707 = (acc_721, s_722) => {
  if (isBraces_703(s_722) && isDolar_701(acc_721.template.last())) {
    return {template: acc_721.template.push(Syntax.fromBraces(List.of(Syntax.fromNumber(acc_721.interp.size)), s_722)), interp: acc_721.interp.push(s_722.inner())};
  } else if (isDelimiter_702(s_722)) {
    let innerResult = processTemplate(s_722.inner(), acc_721.interp);
    return {template: acc_721.template.push(insertIntoDelimiter_706(s_722, innerResult.template)), interp: innerResult.interp};
  } else {
    return {template: acc_721.template.push(s_722), interp: acc_721.interp};
  }
};
function cloneLineNumber_708(to_723, from_724) {
  if (from_724 && to_723 && typeof to_723.setLineNumber === "function") {
    return to_723.setLineNumber(from_724.lineNumber());
  }
  return to_723;
}
const replace_709 = (acc_725, s_726) => {
  let last_727 = acc_725.template.get(-1);
  let beforeLast_728 = acc_725.template.get(-2);
  if (isBraces_703(s_726) && isDolar_701(last_727)) {
    let index = s_726.inner().first().val();
    assert(acc_725.rep.size > index, "unknown replacement value");
    let replacement = cloneLineNumber_708(acc_725.rep.get(index), beforeLast_728);
    return {template: acc_725.template.pop().concat(replacement), rep: acc_725.rep};
  } else if (isDelimiter_702(s_726)) {
    let innerResult = replaceTemplate(s_726.inner(), acc_725.rep);
    return {template: acc_725.template.push(insertIntoDelimiter_706(s_726, innerResult)), rep: acc_725.rep};
  } else {
    return {template: acc_725.template.push(s_726), rep: acc_725.rep};
  }
};
export function processTemplate(temp_729, interp_730 = List()) {
  return temp_729.reduce(process_707, {template: List(), interp: interp_730});
}
export function replaceTemplate(temp_731, rep_732) {
  return temp_731.reduce(replace_709, {template: List(), rep: rep_732}).template;
}
